// extracted by mini-css-extract-plugin
export default {"container":"ToolbarIcon_container__tEM6Q"};